import { useEffect, useState } from "react";
import { feature } from "topojson-client";

export function useGeo() {
  const [geo, setGeo] = useState(null);
  useEffect(() => {
    Promise.all([
      fetch("/data/countries-50m.json").then((r) => r.json()),
      fetch("/data/cities.json").then((r) => r.json()),
    ]).then(([topo, cities]) => {
      const features = feature(topo, topo.objects.countries).features.filter((f) => f.properties.name !== "Antarctica");
      const names = [...new Set(features.map((f) => f.properties.name))].sort((a, b) => a.localeCompare(b));
      setGeo({ features, cities, names });
    });
  }, []);
  return geo;
}
